import { Component, Input } from '@angular/core';

@Component({
  selector: 'zdb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() description: string;
  @Input() title: string;
}
